import React, { useContext, useEffect } from 'react'
import Logout from '../components/Auth/Logout'
import UserFavoritedFixtures from '../components/Profile/UserFavoritedFixtures'
import UserFavoritedFixturesAPI from '../components/Profile/UserFavoritedFixturesAPI'
import UserFavoritedLeaguesAPI from '../components/Profile/UserFavoritedLeaguesAPI'
import UserFavoritedTeams from '../components/Profile/UserFavoritedTeams'
import UserFavoritedTeamsAPI from '../components/Profile/UserFavoritedTeamsAPI'
import StateContext from '../StateContext'

function ProfilePage() {

    const appState = useContext(StateContext)

    useEffect(() => {

        try {
            
        } catch (error) {
            
        }

    }, [appState.loggedIn, appState.userId])

    if (!appState.loggedIn) return <p>Logg inn</p>

    return (
        <div className="container my-4">

            <div className="card card-header font-weight-bold mt-4">Favorittligaer internasjonal fotball</div>
            <UserFavoritedLeaguesAPI />

            <div className="card card-header font-weight-bold mt-4">Favorittlag internasjonal fotball</div>
            <UserFavoritedTeamsAPI />

            <div className="card card-header font-weight-bold mt-4">Favorittkamper internasjonal fotball</div>
            <UserFavoritedFixturesAPI />

            <div className="card card-header font-weight-bold mt-4">Favorittlag lokalfotball</div>
            <UserFavoritedTeams />

            <div className="card card-header font-weight-bold mt-4">Mine kamper lokalfotball</div>
            <UserFavoritedFixtures />

            <Logout />

        </div>
    )
}
export default ProfilePage